import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

const searchData = [
  { label: 'Overview', path: '/design' },
  { label: 'Methodology', path: '/design/methodology', section: 'Methodology' },
  { label: 'Design Principles', path: '/design/methodology', section: 'Methodology' },
  { label: 'Best Practices', path: '/design/methodology', section: 'Methodology' },
  { label: 'Simplicity & Focus', path: '/design/methodology', scrollTo: 'simplicity-focus', section: 'Methodology' },
  { label: 'Intuitive & Cohesive', path: '/design/methodology', scrollTo: 'intuitive-cohesive', section: 'Methodology' },
  { label: 'Communicate & Forgive', path: '/design/methodology', scrollTo: 'communicate-forgive', section: 'Methodology' },
  { label: 'Grounded in People', path: '/design/methodology', scrollTo: 'grounded-in-people', section: 'Methodology' },
  { label: 'Data Visualization', path: '/design/methodology', scrollTo: 'data-visualization', section: 'Methodology' },
  { label: 'Resources', path: '/design/methodology', scrollTo: 'resources', section: 'Methodology' },
  { label: 'Logos', path: '/design/logo', section: 'Logos' },
  { label: 'YipitData Logo', path: '/design/logo', section: 'Logos' },
  { label: 'Spendhound Logo', path: '/design/logo', section: 'Logos' },
  { label: 'Signals Logo', path: '/design/logo', section: 'Logos' },
  { label: 'Colors', path: '/design/colors', section: 'Colors' },
  { label: 'Branding', path: '/design/colors', scrollTo: 'brand-colors', section: 'Colors' },
  { label: 'Charts & Visualizations', path: '/design/colors', scrollTo: 'chart-colors', section: 'Colors' },
  { label: 'User Interface', path: '/design/colors', scrollTo: 'ui-colors', section: 'Colors' },
  { label: 'Typography', path: '/design/font', section: 'Typography' },
  { label: 'Roboto', path: '/design/font', section: 'Typography' },
  { label: 'Bitter', path: '/design/font', section: 'Typography' },
  { label: 'Slides', path: '/design/slides', section: 'Slides' },
  { label: 'Letterheads', path: '/design/letterhead', section: 'Letterheads' },
  { label: 'Imagery', path: '/design/imagery', section: 'Imagery' },
  { label: 'LinkedIn Banners', path: '/design/imagery', scrollTo: 'linkedin-banners', section: 'Imagery' },
  { label: 'Zoom Backgrounds', path: '/design/imagery', scrollTo: 'zoom-backgrounds', section: 'Imagery' },
  { label: 'Photography', path: '/design/imagery', scrollTo: 'photography', section: 'Imagery' },
  { label: 'Email Signatures', path: '/design/email', section: 'Email Signatures' },
  { label: 'Data Visualizations', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Line Chart', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Area Chart', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Stacked Area Chart', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Scatter Plot', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Bubble Chart', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Bar Chart', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Heatmap', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Pie Chart', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Data Table', path: '/design/charts', section: 'Data Visualizations' },
  { label: 'Sigma', path: '/design/sigma', section: 'Sigma' },
];

class DesignSearch extends Component {
  constructor(props) {
    super(props);
    this.state = { query: '', results: [], isOpen: false, highlightedIndex: -1 };
    this.wrapperRef = React.createRef();
    this.dropdownRef = React.createRef();
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ isOpen: false, highlightedIndex: -1 });
    }
  }

  handleChange = (e) => {
    const query = e.target.value;
    if (!query.trim()) {
      this.setState({ query, results: [], isOpen: false, highlightedIndex: -1 });
      return;
    }
    const lower = query.toLowerCase();
    const results = searchData.filter(item =>
      item.label.toLowerCase().includes(lower) ||
      (item.section && item.section.toLowerCase().includes(lower))
    );
    this.setState({ query, results, isOpen: results.length > 0, highlightedIndex: -1 });
  }

  handleKeyDown = (e) => {
    const { results, highlightedIndex, isOpen } = this.state;
    if (!isOpen) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = Math.min(highlightedIndex + 1, results.length - 1);
      this.setState({ highlightedIndex: next }, () => this.scrollHighlightedIntoView());
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = Math.max(highlightedIndex - 1, 0);
      this.setState({ highlightedIndex: prev }, () => this.scrollHighlightedIntoView());
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const index = highlightedIndex >= 0 ? highlightedIndex : 0;
      if (results[index]) this.handleSelect(results[index]);
    } else if (e.key === 'Escape') {
      this.setState({ isOpen: false, highlightedIndex: -1 });
    }
  }

  scrollHighlightedIntoView() {
    if (!this.dropdownRef.current) return;
    const highlighted = this.dropdownRef.current.querySelector('.design-search-result.highlighted');
    if (highlighted) highlighted.scrollIntoView({ block: 'nearest' });
  }

  handleSelect = (item) => {
    this.setState({ query: '', results: [], isOpen: false, highlightedIndex: -1 });
    if (this.inputRef.current) this.inputRef.current.blur();
    this.props.history.push({
      pathname: item.path,
      state: item.scrollTo ? { scrollTo: item.scrollTo } : undefined
    });
  }

  render() {
    const { query, results, isOpen, highlightedIndex } = this.state;
    return (
      <div className="design-search" ref={this.wrapperRef}>
        <div className="design-search-input-wrapper">
          <span className="material-symbols-rounded design-search-icon">search</span>
          <input
            ref={this.inputRef}
            className="design-search-input"
            type="text"
            placeholder="Search"
            value={query}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
          />
          {query && (
            <span
              className="material-symbols-rounded design-search-clear"
              onClick={() => this.setState({ query: '', results: [], isOpen: false, highlightedIndex: -1 })}
            >close</span>
          )}
        </div>
        {isOpen && (
          <div className="design-search-dropdown" ref={this.dropdownRef}>
            {results.map((item, i) => (
              <div
                key={i}
                className={'design-search-result' + (i === highlightedIndex ? ' highlighted' : '')}
                onClick={() => this.handleSelect(item)}
                onMouseEnter={() => this.setState({ highlightedIndex: i })}
              >
                <span className="design-search-result-label">{item.label}</span>
                {item.section && item.section !== item.label && (
                  <span className="design-search-result-section">{item.section}</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(DesignSearch);
